import { render } from "./v-mention.vue?vue&type=template&id=516cfa10&scoped=true"
import script from "./v-mention.vue?vue&type=script&lang=js"
export * from "./v-mention.vue?vue&type=script&lang=js"

import "./v-mention.vue?vue&type=style&index=0&id=516cfa10&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516cfa10"]])

export default __exports__